// src/main.js

import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'

import './assets/style.css'
import './assets/tailwind.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap'
import '@coreui/coreui/dist/css/coreui.min.css'



import { library } from '@fortawesome/fontawesome-svg-core'
import { faThermometerHalf } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faThermometerHalf)

const app = createApp(App)

app.component('font-awesome-icon', FontAwesomeIcon)
app.use(router)
import CoreuiVue from '@coreui/vue'
import CIcon from '@coreui/icons-vue'
import * as iconSet from '@coreui/icons'


fetch('/settings.json')
  .then(res => res.json())
  .then(settings => {
    const apiBase = settings.apiURL

    const app = createApp(App)

    app.component('font-awesome-icon', FontAwesomeIcon)
    app.use(router)
    app.use(CoreuiVue)
    app.component('CIcon', CIcon)
    app.component('font-awesome-icon', FontAwesomeIcon)
    app.provide('icons', iconSet)

    // ✅ Global API setup
    app.config.globalProperties.$API = axios
    app.config.globalProperties.$GetListProduct = apiBase + 'Read/GetListReadingPlant'
    app.config.globalProperties.$GetListPot = apiBase + 'Read/GetListPotPlant'
    app.config.globalProperties.$GetListReadingPlantSummary = apiBase + 'Read/GetListReadingPlantSummary'
    app.config.globalProperties.$GetAverageValue = apiBase + 'Read/GetAverageValue'


    app.config.globalProperties.$InsertSensorAssignment = apiBase + 'Insert/InsertAssignment'


    app.mount('#app')
  })
  .catch(err => {
    console.error('⚠️ Failed to load setting.json', err)
    alert('Failed to load application configuration.')
  })